var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikebutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8858 0.404785C24.0607 0.404785 27.3833 4.55539 27.3833 10.1442C27.3833 14.4804 23.4575 19.2574 15.7273 24.6232C15.2199 24.9747 14.6173 25.163 14 25.163C13.3827 25.163 12.7801 24.9747 12.2727 24.6232C4.54247 19.2574 0.616707 14.4804 0.616707 10.1442C0.616707 4.55539 3.93576 0.404785 9.1142 0.404785C10.9825 0.404785 12.2512 1.05789 14 2.54611C15.7487 1.05789 17.0157 0.404785 18.8858 0.404785Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikebutton);
export default __webpack_public_path__ + "static/media/likebutton.a276df1c.svg";
export { ForwardRef as ReactComponent };